import createDOMPurify from 'dompurify';
import { datadogLogs } from '@datadog/browser-logs';
import axios from 'axios';

export const generateKey: (length?: number) => string = (length = 8) => {
  return Math.random().toString(16).substr(2, length);
};

type SanitizeOptions = {
  ALLOWED_TAGS?: string[]; // set tag whitelist
  ALLOWED_ATTR?: string[]; // set attribute whitelist
};

const defaultSanitizeOptions: SanitizeOptions = {
  ALLOWED_TAGS: [
    'p',
    'b',
    'i',
    'em',
    'strong',
    'ol',
    'li',
    'a',
    'sup',
    'br',
    'hr',
    'h1',
    'h2',
    'h3',
    'h4',
    'ol',
    'ul',
  ],
  // don't allow attributes by default
  ALLOWED_ATTR: ['href', 'target', 'data-*'],
};

/**
 * sanitize an untrusted HTML string so it only contains allowed HTML
 *
 * returns a sanitized HTML string
 * @param dirty a string containing untrusted HTML
 * @param options an object containing the allowed tags and attributes
 * (refer to https://github.com/cure53/DOMPurify/ for full options)
 */
export const sanitize = (dirty: string, options?: SanitizeOptions) => {
  if (typeof window !== 'undefined') {
    const DOMPurify = createDOMPurify(window);
    return DOMPurify.sanitize(dirty, { ...defaultSanitizeOptions, ...options });
  }

  return dirty;
};

export const logError = (error: string, context: object | undefined): void => {
  datadogLogs.logger.error(error, context);
};

export const postDataToAnalyticsApi = async (data: any): Promise<any> => {
  const url = `${process.env.REACT_APP_ITERABLE_URL}/track`;
  const authToken = `Basic ${process.env.REACT_APP_ITERABLE_TOKEN}`;

  const requestOpts: any = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: authToken,
      'Content-Type': 'application/json',
    },
    url,
    data,
  };

  return axios(requestOpts);
};
